<template>
  <span class="pb-scan-mark" aria-hidden="true"></span>
</template>

<script setup lang="ts">
/**
 * The scan mark: a quarter-arc turning in a faint track, the product at work (`pb-scan`, `tokens/effects.css`).
 *
 * A control shows it in its icon's place while the request it started is out, so the control keeps its shape and its
 * label (DESIGN.md, Buttons: loading is a state of the button, not a different button). It is decoration: the control
 * says it is busy, so the mark is hidden from assistive technology and says nothing.
 *
 * It turns only while that request is genuinely out. A rotation with nothing behind it is the product claiming effort it
 * is not making, and the reader has no way to check.
 */
</script>

<style>
@layer pb-components {
  /* At the small icon size, because it stands where a control's leading icon stood. The track is the hairline and the
     arc is the live dot, so the mark reads as the same object as the live-state dot it sits among. Under
     prefers-reduced-motion the floor in `reset.css` lands it on its start position, a still arc. */
  .pb-scan-mark {
    display: inline-block;
    flex: none;
    width: var(--icon-sm);
    height: var(--icon-sm);
    border: 2px solid var(--hairline);
    border-top-color: var(--dot-live);
    border-radius: var(--radius-full);
    animation: pb-scan var(--scan-duration) linear infinite;
  }
}
</style>
